import { OrderedMap } from "immutable";

const TaskListMap = OrderedMap;

export default TaskListMap;
